export default __webpack_public_path__ + "static/media/plant1.d5230826.PNG";